export const GeneralTab = ({props}) => {
    return <div style={{textAlign: 'left'}}>
        <div>Version 1.0</div><p/>
        <ul>
            <li>Demo For Clark</li>
        </ul><p/>
    </div>
}